import { createSelector } from 'reselect';

import { selectGetConfigValue } from '@pressreader/config';
import type { IArticle } from '@pressreader/content-types';

import { selectArticleByIdAndLanguageSelector } from './articles';
import { selectArticleRestrictionsByArticleIdSelector } from './restrictions';

export const selectRadioActive = createSelector(
    selectArticleByIdAndLanguageSelector,
    selectArticleRestrictionsByArticleIdSelector,
    selectGetConfigValue,
    (getArticleByIdSelector, getArticleRestrictionsByArticleId, getConfigValue) =>
        (articleId = '', language: IArticle['language'] | null): boolean => {
            const article = getArticleByIdSelector(articleId, language);

            const { languages } = getConfigValue<{ languages: string[] }>('radio', {
                languages: [],
            });

            const languageSupported = article?.language ? languages.indexOf(article.language) >= 0 : true;
            const articleRestrictions = getArticleRestrictionsByArticleId(article ? { article } : { articleId, language });

            return languageSupported && !articleRestrictions?.sound;
        },
);
